
let FREur = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
});

export function formatEurPrice(price, lgDown) {
    const floatPrice = parseFloat(price);

    if (lgDown && floatPrice >= 1000) {
        // Affichage simplifié en K€ uniquement si >= 1000
        const rounded = (floatPrice / 1000).toFixed(1);
        return `${rounded} K€`;
    }

    return FREur.format(floatPrice);
}

export function formatTotal(price) {
    return price.toFixed(2);
}

export function formatEurPriceAndRoundUtil(price, lgUp)  {
    return formatEurPrice(formatTotal(parseFloat(price)), !lgUp);
}

